import classNames from "classnames"

import { Color } from "../../../../constants/V2/color"
import LayoutItem from "../../Layouts/LayoutItem"

import GatsbyStoryblokImage from "@components/elements/V2/GatsbyStoryblokImage"
import CircleCheckIcon from "@components/elements/V2/Icons/CircleCheckIcon"
import TextItem from "@components/elements/V2/TextItem"
import Typography from "@components/elements/V2/Typography"
import {
  getAccentColor,
  getBackgroundColorClass,
  getBorderColorClass,
  getTextColorClass,
} from "@utils/V2/color"
import React from "react"

type Item = {
  text: string
  hideIcon: boolean
}

type Props = {
  backgroundColor: Color
  borderColor?: Color
  iconUrl?: string
  iconAlt?: string
  titleText: string
  items: Item[]
  size?: "small" | "medium"
  mobileGridOrder?: number
}

const List = ({
  backgroundColor,
  borderColor = Color.White,
  titleText,
  iconUrl,
  iconAlt,
  items,
  size = "medium",
  mobileGridOrder,
  ...props
}: Props) => {
  return (
    <LayoutItem
      mobileGridOrder={mobileGridOrder}
      as="div"
      animateOnScroll
      className={classNames(
        getBackgroundColorClass(backgroundColor),
        getBorderColorClass(borderColor),
        "p-lg rounded-md col-span-full flex flex-col justify-between gap-20 border-2",
        size === "small" ? "md:col-span-3" : "md:col-span-2 lg:col-span-4"
      )}
      {...props}
    >
      <div className="flex flex-1 flex-col items-start gap-16">
        {iconUrl && (
          <GatsbyStoryblokImage
            image={iconUrl}
            alt={iconAlt || "Info Block Icon"}
            width={40}
          />
        )}

        <Typography
          weight="medium"
          size="body-md"
          font="grotesk"
          color={getAccentColor(backgroundColor)}
          text={titleText}
        />

        <div className="mt-auto flex flex-col gap-8">
          {items.map((blok) => (
            <TextItem
              key={blok.text}
              text={blok.text}
              hideIcon={blok.hideIcon}
              textColor={getAccentColor(backgroundColor)}
              size="body-md"
              icon={
                <CircleCheckIcon className={getTextColorClass(Color.Blue)} />
              }
            />
          ))}
        </div>
      </div>
    </LayoutItem>
  )
}

export default List
